import { apiSlice } from "../api/apiSlice";

export const taskApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getTasks: builder.query({
      query: () => "/tasks",
    }),
    getTask: builder.query({
      query: (taskId) => `/tasks/${taskId}`,
    }),
    addTask: builder.mutation({
      query: (newTask) => ({
        url: "/tasks",
        method: "POST",
        body: newTask,
      }),
      async onQueryStarted(arg, { queryFulfilled, dispatch }) {
        // pessimistic cache update
        try {
          const { data: task } = await queryFulfilled;

          dispatch(
            taskApi.util.updateQueryData("getTasks", undefined, (draft) => {
              draft.push(task);
            })
          );
        } catch (err) {
          console.log(err);
        }
      },
    }),
    editTask: builder.mutation({
      query: (task) => ({
        url: `/tasks/${task.id}`,
        method: "PATCH",
        body: task,
      }),
      async onQueryStarted(arg, { queryFulfilled, dispatch }) {
        // pessimistic cache update
        try {
          const { data: task } = await queryFulfilled;

          // update single task
          dispatch(
            taskApi.util.updateQueryData("getTask", arg.id, (draft) => {
              return task;
            })
          );

          // update all tasks
          dispatch(
            taskApi.util.updateQueryData("getTasks", undefined, (draft) => {
              return draft.map((t) => (t.id === task.id ? task : t));
            })
          );
        } catch (err) {
          console.log(err);
        }
      },
    }),
    deleteTask: builder.mutation({
      query: (taskId) => ({
        url: `/tasks/${taskId}`,
        method: "DELETE",
      }),
      async onQueryStarted(arg, { queryFulfilled, dispatch }) {
        // optimistic cache update
        const resultAction = dispatch(
          taskApi.util.updateQueryData("getTasks", undefined, (draft) => {
            return draft.filter((t) => t.id !== arg);
          })
        );

        try {
          await queryFulfilled;
        } catch (err) {
          // undo if delete failed
          resultAction.undo();
        }
      },
    }),
  }),
});

export const {
  useGetTasksQuery,
  useGetTaskQuery,
  useAddTaskMutation,
  useEditTaskMutation,
  useDeleteTaskMutation,
} = taskApi;
